import { render, staticRenderFns } from "./QuickDrawer.vue?vue&type=template&id=3f5e1bc8&scoped=true"
import script from "./QuickDrawer.vue?vue&type=script&lang=js"
export * from "./QuickDrawer.vue?vue&type=script&lang=js"
import style0 from "./QuickDrawer.vue?vue&type=style&index=0&id=3f5e1bc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5e1bc8",
  null
  
)

export default component.exports